// extracted by mini-css-extract-plugin
export default {"wrapper":"Successfull_wrapper__LtNKd","infoContainer":"Successfull_infoContainer__bxeRv","img":"Successfull_img__qjG7f"};